import { makeStyles, Theme } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import clsx from "clsx";
import React, { FC } from "react";
import { StudentStatus } from "../../modules/student/types";
import { AdapterLink } from "../Adopter";
import BlinkingDot from "../BlinkingDot";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "relative",
  },
  circleCont: {
    borderStyle: "solid",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  hoverable: {
    "&:hover": {
      outline: "1px solid #C5C5C5",
      boxShadow: "0px 0px 8px #C2C9D6B3",
      cursor: "pointer",
    },
  },
  [StudentStatus.REJECTED]: {
    borderColor: theme.palette.error.main,
  },
  [StudentStatus.APPROVED]: {
    borderColor: theme.palette.success.main,
  },
  [StudentStatus.PENDING]: {
    borderColor: theme.palette.warning.main,
  },
  [StudentStatus.DEFAULT]: {
    borderColor: "#A1A4AC",
  },
}));

interface AvatarWithStatusProps {
  hasNewMessage?: boolean;
  borderWidth?: number;
  hoverable?: boolean;
  status?: StudentStatus;
  size?: number;
  alt?: string;
  src: string;
  to?: string;
}

export const AvatarWithStatus: FC<AvatarWithStatusProps> = React.memo(
  ({
    hasNewMessage = false,
    borderWidth = 3,
    hoverable = false,
    status = StudentStatus.DEFAULT,
    size = 76,
    alt,
    src,
    to,
  }) => {
    const classes = useStyles();

    const avatarSize = 2 * Math.floor((size / 2) * 0.789); //round to nearest even number

    return (
      <div className={classes.root}>
        <BlinkingDot isVisible={hasNewMessage}>
          <div
            className={clsx(
              classes.circleCont,
              classes[status],
              hoverable && classes.hoverable,
            )}
            style={{
              width: `${size}px`,
              height: `${size}px`,
              borderWidth: `${borderWidth}px`,
            }}
          >
            <AdapterLink to={to}>
              <Avatar
                alt={alt}
                src={src}
                style={{
                  width: `${avatarSize}px`,
                  height: `${avatarSize}px`,
                  borderWidth: `${borderWidth}px`,
                }}
              />
            </AdapterLink>
          </div>
        </BlinkingDot>
      </div>
    );
  },
);
